import { init as initRequester, setAuthorizationToken } from '@front/common/src/api/requester';
import { DEFAULT_LOCALE_BY_COUNTRY, LOCALES_BY_COUNTRY } from '@front/common/src/constants/country';
import { init as initDucks } from '@front/common/src/ducks/utils';
import { errorNotifier } from '@front/common/src/errors/error-notifier';
import { getCurrentCountry } from '@front/common/src/utils/country';
import { setMomentLocale } from '@front/common/src/utils/moment';

import { setI18nConfig, type Translations } from '@front/i18n';

import { getWebAppLocale, setCountry } from './country';

export type InitializeWebAppArgs = {
  appName: string;
  i18nConfig: {
    translations: Translations;
  };
};

export const initializeWebApp = async ({ appName, i18nConfig }: InitializeWebAppArgs) => {
  await setCountry();
  const country = getCurrentCountry(); // when country is set, this is the single common way of getting it

  setI18nConfig({
    ...i18nConfig,
    notifier: errorNotifier.notify,
    locale: getWebAppLocale(),
    supportedLocales: LOCALES_BY_COUNTRY[country],
    defaultLocale: DEFAULT_LOCALE_BY_COUNTRY[country],
  });
  setMomentLocale();

  const authToken = window.wecasa.token;
  if (authToken) {
    setAuthorizationToken(`Bearer ${authToken}`);
  }

  const baseURL = `${window.wecasa.siteUrl}api/v1`;
  initRequester(baseURL, appName);
  initDucks(errorNotifier);
};
